import {  getQueryPrediction, getDownloadData, getCsrf, setComputeSession, runSASCode, pollSASJob, getResult, validateComputeSession, submitFile } from '@/services/httpClient.js'
import { store }  from '@/store/index.js'
import { getJsonOutput } from '@/services/apiService.js'

export const executeModelPredictor = async (data) => {
  // data contains info from features:
  // REPORTTYPE, PRODUCTTYPE, READOUTDATE_DIFF, MILEAGE_DIFF,CHASSILIST_COUNTER and sub_report
  return getQueryPrediction(JSON.stringify(data))
}


export const getS3JsonData = async(fileName) => {
  try {
    var response = await getJsonOutput(fileName)
    return response
  } catch(error) {
      return error
  }
}

export const executeHttpCall = async (params, data, isReport) => {
  if (!await fetchCsrf()) {
    console.log('failed to get csrf')
    return
  }

  // const sessionBody = { version: 1, name: 'ProductAnalytics', description: 'This is my session for doing some simple work.', attributes: {}, environment: { options: ['memsize=4g', 'fullstimer'] } }
  const sessionBody = { 
    version: 1, name: 'PASession', 
    description: 'Product analytics session',"environment": {
    options: [
      "timezone='GMT+02:00'"
    ]
  } }
  await initializeSession(sessionBody, isReport)

  var sessionId = store.state.sessionStatus.sessionId
  if (isReport) {
    sessionId = store.state.sessionStatus.parallelSessionId // Get parallel sessionid for report calls to SAS
  }

  const jobData = createJobDataObject(params, data)

  const jobId = await startJob(sessionId, JSON.stringify(jobData))

  if (jobId) {
    let jobStatus = await getJobStatus(sessionId, jobId)
    console.log('JobStatus: ', jobStatus)
    // getLog(sessionId)

    let counter = 0
    while (jobStatus !== 'completed' && jobStatus !== 'warning') {
      await wait(500)
      jobStatus = await getJobStatus(sessionId, jobId)

      if (jobStatus === 'error' || jobStatus === undefined || jobStatus === 'canceled') {
        await wait(1000)
        counter += 1
        if (counter === 2) {
          console.log('Aborting current session due to unexpected error.')
          break
        }
        console.log('An error has occurred with jobStatus: ', jobStatus)
        await setSession(JSON.stringify(sessionBody))
        sessionId = store.state.sessionStatus.sessionId
        const jobData = createJobDataObject(params, data)
        const jobId = await startJob(sessionId, JSON.stringify(jobData))
        jobStatus = await getJobStatus(sessionId, jobId)
        console.log('Creating new session due to unexpected error. Current jobStatus: ', jobStatus)
        return await getJobResults(sessionId, params.resultFile)
      }
    }
  }

  return await getJobResults(sessionId, params.resultFile)
}

export const executeDownloadDataHttpCall = async (data) => {
  return await getDownloadData(data).then((response) => {
    return response
  }).catch(err => {
    console.log('Error downloading data: ', err)
    return false
  })
}
const initializeSession = async (sessionBody, isReport) => {
  if (isReport) {
    // Creating new parallel session if reports are called
    return await setParallelSession(JSON.stringify(sessionBody))
  }
  if (!store.state.sessionStatus.sessionId) {
    return await setSession(JSON.stringify(sessionBody))
  }
  const sessionAvailable = await validateSession(store.state.sessionStatus.sessionId)
  if (!sessionAvailable) {
    return await setSession(JSON.stringify(sessionBody))
  }
}
const createJobDataObject = (params, data) => {
  var selectedEnvUrl = ''
  var selectedEnv = ''
  if (store.state.selectedEnvironment == null) {
    // selectedEnvUrl = '/opt/sas/sasdata/developers/paola/code/programs/GUIAPI/'
    selectedEnvUrl = '/sna/projects/ProductAnalytics/prod/programs/code/programs/GUIAPI/'
    selectedEnv = 'Production'
  } else {
    selectedEnvUrl = store.state.selectedEnvironment.url
    selectedEnv = store.state.selectedEnvironment.description
  }
  params.env = selectedEnv
  params.unlimited = store.state.isODP_unlimited ? 'Y' : 'N'
  params.limited = store.state.isODP_limited ? 'Y' : 'N'
  const variables = params
  if (data) {
    variables.data = JSON.stringify(data)
  }
  return {
    version: 2,
    name: 'Broker program',
    description: 'Product Analytics Broker Program',
    variables: variables,
    code: '%include \'' + selectedEnvUrl + params._program + '.sas\';'
  }
}
export const submitFile2SAS = (file) => {
  console.log('submitFile2SAS' + file)
  return submitFile(file).then((response) => {
    console.log('File id: ' + response.data.fileId)
    console.log('Job id: ' + response.data.jobId)
    return response.data
  }).catch(err => {
    console.log('submitFile() error: ', err)
    return false
  })
}

const fetchCsrf = () => {
  return getCsrf().then(response => {
    store.commit('setCsrf', response.data)
    return true
  }).catch(err => {
    console.log('csrf error: ', err)
    return false
  })
}
const setSession = (body) => {
  console.log('Creating new session...')
  return setComputeSession(body).then(response => {
    console.log('Session id: ' + response.data.id)
    store.commit('setSessionStatus', { sessionId: response.data.id })
  }).catch(error => {
    store.commit('setSessionStatus', { sessionId: null })
    console.log('setComputeSession() error: ', error)
  })
}
const setParallelSession = (body) => {
  console.log('Creating new parallel session...')
  return setComputeSession(body).then(response => {
    console.log('Parallel session id: ' + response.data.id)
    store.commit('setSessionStatus', { parallelSessionId: response.data.id })
  }).catch(error => {
    store.commit('setSessionStatus', { parallelSessionId: null })
    console.log('setParallelSession() error: ', error)
  })
}

const startJob = (sessionId, data) => {
  console.log('startJob. sessionId:' + sessionId)
  return runSASCode(sessionId, data).then(response => {
    console.log('Job id: ' + response.data.id)
    return response.data.id
  }).catch(error => {
    console.log('runSASCode() error: ', error)
  })
}
const getJobStatus = (sessionId, jobId) => {
  return pollSASJob(sessionId, jobId).then(response => {
    return response.data
  }).catch(error => {
    console.log('pollSASJob() error: ', error)
  })
}
const getJobResults = (sessionId, refId) => {
  console.log('getJobResults:' + sessionId)
  return getResult(sessionId, refId).then(response => {
    return response.data
  }).catch(error => {
    console.log('getResult() error: ', error)
  })
}
// const getLog = (sessionId) => {
//   return retrieveJobLog(sessionId).then(response => {
//     response.data.items.forEach(element => {
//       // if (element.line && !element.line.includes('      '))console.log('Log:' + JSON.stringify(element.line))
//     })
//     // console.log('Log:' + JSON.stringify(response.data.items))
//   }).catch(error => {
//     console.log('getLog() error: ', error)
//   })
// }
const validateSession = (sessionId) => {
  return validateComputeSession(sessionId).then(response => {
    console.log('Checking if session is still active')
    if (response.status === 200) {
      console.log('Session active, reusing existing one: ', sessionId)
      if (response.data === 'idle') {
        console.log('validatecomputesession:' + response.data)
        return false
      }
      if (response.data === 'running') {
        console.log('validatecomputesession:' + response.data)
      }
      return true
    }
    console.log('Session not active')
    return false
  }).catch(error => {
    console.log('validateComputeSession() error:', error)
    return false
  })
}
const wait = (ms = 5000) => {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}
